export default __webpack_public_path__ + "static/jqQDdTiG-20b486f60a2f01d3d83da5de348c72a7.jpeg";